import { DealStatus } from "./Deal.constants";
import { Deal } from "./Deal.types";

export function isDealActive(deal: Deal) {
    return ![
        DealStatus.TERM_SHEET_SIGNED,
        DealStatus.FUNDED,
        DealStatus.PAUSED,
        DealStatus.TERMINATED,
    ].includes(deal.status as DealStatus);
}
